import { FieldProps, getIn } from 'formik';
import { NumberInput } from '../inputs/NumberInput';

interface NumberInputFieldProps extends FieldProps {
  id?: string;
  error?: boolean;
  suffix?: string;
  highlightFullBorder?: boolean;
  validateOnBlur?: boolean;
  onAfterChange?: (value?: number) => void;
}

export const NumberInputField = ({ 
  form, 
  field, 
  highlightFullBorder, 
  validateOnBlur, 
  onAfterChange, 
  ...props 
}: NumberInputFieldProps) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  return (
    <NumberInput
      {...field}
      {...props}
      key={(props.id || field.name)}
      id={props.id || field.name}
      error={touched && !!error}
      helperText={(touched && error) || ''}
      highlightFullBorder={highlightFullBorder}
      validateOnBlur={validateOnBlur}
      onAfterChange={onAfterChange}
    />
  );
};
